import { TextField } from "@mui/material";
import Field from "components/Field";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { validateVimeoValue } from "utils/vimeoHelper";
import { SkuDeliveryMethodSettingProps } from "../SkuDeliveryMethodSetting";

interface VimeoSettingProps {
  item: SkuDeliveryMethodSettingProps;
}

const VimeoSetting = ({ item }: VimeoSettingProps) => {
  const { formatMessage: t } = useIntl();
  const validateVimeo = useCallback(
    (value: string) => {
      return validateVimeoValue(value, t);
    },
    [t]
  );

  return (
    <Field
      name={`settingValues[${item.fieldIndex}].value`}
      customValidator={validateVimeo}
      required
    >
      {({ input, meta }) => (
        <TextField
          required
          variant="standard"
          fullWidth
          label="Vimeo URL or ID"
          placeholder="Enter Vimeo URL or numeric ID"
          helperText={
            meta.error && meta.submitFailed
              ? meta.error
              : undefined
          }
          error={meta.error && meta.submitFailed}
          {...input}
          value={input.value?.trim() || ""}
        />
      )}
    </Field>
  );
};

export default VimeoSetting;